import { Controller } from "@hotwired/stimulus"

// Поиск по длинному <select> (поводы в форме шаблона): набранный текст
// оставляет в списке только совпавшие строки. Опции пересобираем, а не прячем:
// Safari `hidden` у <option> не уважает. Выбранная остаётся всегда, иначе
// поиск молча сбросил бы значение формы; совпала одна — выбираем её.
export default class extends Controller {
  static targets = ["select"]

  connect() {
    this.options = Array.from(this.selectTarget.options)
  }

  filter(event) {
    const query = event.target.value.trim().toLowerCase()
    const select = this.selectTarget
    const current = select.value
    const matches = this.options.filter((o) => o.value === "" || o.text.toLowerCase().includes(query))
    const kept = this.options.filter((o) => o.value === current || matches.includes(o))
    select.replaceChildren(...kept)
    select.value = current

    const found = matches.filter((o) => o.value !== "")
    if (query && found.length === 1) select.value = found[0].value
  }
}
